import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#dispositionskredit

	{
        "abloesen": Boolean,
        "antragstellerIds": [String],
        "beanspruchterBetrag": BigDecimal,
        "bic": String,
        "glaeubiger": String,
        "iban": String,
        "verfuegungsrahmen": BigDecimal,
        "zinssatz": BigDecimal,
    }


*/
export const schemaEuropaceUpdateDispositionskredit = z
    .object({
        abloesen: z.optional(z.boolean()),
        antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
        beanspruchterBetrag: z.optional(schemaBigDecimal),
        bic: z.optional(z.string()),
        glaeubiger: z.optional(z.string()),
        iban: z.optional(z.string()),
        verfuegungsrahmen: z.optional(schemaBigDecimal),
        zinssatz: z.optional(schemaBigDecimal),
    })
    .strip();

export type SchemaEuropaceUpdateDispositionskredit = z.infer<typeof schemaEuropaceUpdateDispositionskredit>;
